(() => {
  if (window.__macFabChatLauncherBound) return;
  window.__macFabChatLauncherBound = true;

  const SELECTORS = [
    '[data-chat-launcher]',
    '[aria-label*="chat" i]', '[title*="chat" i]',
    '[aria-label*="message" i]', '[title*="message" i]',
    '[class*="heichat" i] button', '[id*="heichat" i] button',
    '[class*="hei-chat" i] button', '[id*="hei-chat" i] button',
    '[class*="chat-widget" i] button', '[class*="chat-button" i]',
    '[class*="chat-launcher" i]', '[id*="chat-launcher" i]',
    '[data-testid*="chat" i]', 'button[class*="chat" i]'
  ];

  const FRAME_HINT = /hei\s*chat|heichat|chat|message|support|assistant/i;

  function visible(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    const r = el.getBoundingClientRect();
    const s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }

  function clickCandidate(el) {
    if (!visible(el) || el.closest?.('[data-mf-open-chat]')) return false;
    try {
      el.dispatchEvent(new PointerEvent('pointerdown', { bubbles:true, cancelable:true, pointerType:'mouse' }));
      el.dispatchEvent(new MouseEvent('mousedown', { bubbles:true, cancelable:true, view:window }));
      el.click();
      el.dispatchEvent(new MouseEvent('mouseup', { bubbles:true, cancelable:true, view:window }));
      el.dispatchEvent(new PointerEvent('pointerup', { bubbles:true, cancelable:true, pointerType:'mouse' }));
      return true;
    } catch (_) {
      try { el.click(); return true; } catch (_) { return false; }
    }
  }

  function searchRoot(root, customSelector) {
    if (!root?.querySelectorAll) return false;

    if (customSelector) {
      try {
        const custom = root.querySelector(customSelector);
        if (clickCandidate(custom)) return true;
      } catch (_) {}
    }

    for (const sel of SELECTORS) {
      let nodes = [];
      try { nodes = [...root.querySelectorAll(sel)]; } catch (_) {}
      for (const el of nodes) if (clickCandidate(el)) return true;
    }

    // HeiChat and similar app embeds often use open shadow roots.
    const all = root.querySelectorAll('*');
    for (const host of all) {
      if (host.shadowRoot && searchRoot(host.shadowRoot, customSelector)) return true;
    }

    // Recurse into frames only when the browser permits same-origin access.
    for (const frame of root.querySelectorAll('iframe')) {
      try {
        const doc = frame.contentDocument;
        if (doc && searchRoot(doc, customSelector)) return true;
      } catch (_) {}
    }
    return false;
  }

  function findChatFrame() {
    const frames = [...document.querySelectorAll('iframe')];
    return frames.find((frame) => {
      const haystack = [frame.src, frame.id, frame.className, frame.title, frame.name].join(' ');
      return FRAME_HINT.test(haystack) && visible(frame);
    }) || frames.find((frame) => {
      if (!visible(frame)) return false;
      const r = frame.getBoundingClientRect();
      return r.right > innerWidth - 180 && r.bottom > innerHeight - 180;
    });
  }

  function removeGuide() {
    document.querySelector('.mf-chat-guide')?.remove();
    document.querySelector('.mf-chat-highlight')?.remove();
  }

  function showGuide() {
    removeGuide();
    const frame = findChatFrame();
    if (frame) {
      const r = frame.getBoundingClientRect();
      const highlight = document.createElement('div');
      highlight.className = 'mf-chat-highlight';
      highlight.style.left = `${Math.max(8, r.left - 8)}px`;
      highlight.style.top = `${Math.max(8, r.top - 8)}px`;
      highlight.style.width = `${Math.max(64, r.width + 16)}px`;
      highlight.style.height = `${Math.max(64, r.height + 16)}px`;
      document.body.append(highlight);
    }

    const guide = document.createElement('div');
    guide.className = 'mf-chat-guide';
    guide.setAttribute('role', 'status');
    guide.innerHTML = `
      <button class="mf-chat-guide__close" type="button" aria-label="Close">×</button>
      <strong>Open the Mac Fab Wheel Expert</strong>
      <span>Tap the blue chat bubble in the lower-right corner.</span>
      <span class="mf-chat-guide__arrow" aria-hidden="true">↘</span>
    `;
    document.body.append(guide);
    guide.querySelector('.mf-chat-guide__close')?.addEventListener('click', removeGuide);
    setTimeout(removeGuide, 9000);
  }

  function tryOpen(selector) {
    return searchRoot(document, selector || '');
  }

  // App embeds often arrive after page load. Retry briefly before falling back.
  function openWithRetries(selector, attempt = 0) {
    if (tryOpen(selector)) return;
    if (attempt < 6) {
      setTimeout(() => openWithRetries(selector, attempt + 1), 250 + attempt * 100);
      return;
    }
    showGuide();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mf-open-chat]');
    if (!trigger) return;
    event.preventDefault();
    removeGuide();
    openWithRetries(trigger.dataset.chatSelector || '');
  });
})();
